import { render, staticRenderFns } from "./gildwwd_cjcx.vue?vue&type=template&id=18d7d8ac&scoped=true&"
import script from "./gildwwd_cjcx.vue?vue&type=script&lang=js&"
export * from "./gildwwd_cjcx.vue?vue&type=script&lang=js&"
import style0 from "./gildwwd_cjcx.vue?vue&type=style&index=0&id=18d7d8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7d8ac",
  null
  
)

export default component.exports